//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        title: {
            required: true
        },
        baseUrl: {
            required: true
        }
    },
    data: function data() {
        return {
            updateTypes: false,
            items: [],
            adding: false,
            newItem: ''
        };
    },
    mounted: function mounted() {
        var _this = this;

        axios.get('' + this.baseUrl).then(function (response) {
            return _this.items = response.data;
        });
    },

    methods: {
        save: function save() {
            var _this2 = this;

            // add new item
            if (this.adding) {
                console.log(this.newItem);
                axios.post('' + this.baseUrl, { name: this.newItem }).then(function (response) {
                    _this2.adding = false;
                    _this2.items.unshift(response.data);
                    _this2.newItem = false;
                    _this2.$snotify.success('The item was added');
                });

                // update items
            } else {
                // be able to handle multiple items
                console.log(this.items);
                var arrayLength = this.items.length;
                console.log(arrayLength);
                for (var i = 0; i < arrayLength; i++) {
                    console.log('saving ' + this.items[i] + '-' + this.items[i].name);
                    axios.patch(this.baseUrl + '/' + this.items[i].id + '/', { name: this.items[i].name }).then(function (response) {
                        _this2.updateTypes = false;
                        //                            this.$snotify.success('The items were updated')
                    });
                }
                this.$snotify.success('The items were updated');
            }
        },
        edit: function edit() {
            this.updateTypes = !this.updateTypes;
            this.adding = false;
        },
        removeItm: function removeItm(item, idx) {
            var _this3 = this;

            axios.delete(this.baseUrl + '/' + item.id + '/', { id: item.id }).then(function (response) {
                _this3.updateTypes = false;
                _this3.items.splice(idx, 1);
                _this3.$snotify.error('The item was removed');
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/layout/ApiLookupTable.vue
// module id = 4fQS
// module chunks = 0 1